import CustomApiBlock from "../../components/customApiBlock";

export default function CustomApiPage() {
  return <CustomApiBlock />
}
